import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isSubmitting } from 'redux-form';
import get from 'lodash/get';

import transportOrderStatusesIds from 'hh-shared/dist/consts/transportOrderStatusesIds';
import ChangeStatusButton from 'hh-shared/dist/components/transport-order/ChangeStatusButton';
import lang from 'hh-shared/dist/language/services/languageService';
import DeliveredDialog from 'hh-shared/dist/components/transport-order/DeliveredDialog';
import useFormDialogLogic from 'hh-shared/dist/components/transport-order/useFormDialogLogic';

const formName = 'transportFormPreview';

const propTypes = {
  data: PropTypes.object.isRequired,
  submitAcceptForImplementation: PropTypes.func.isRequired,
  submitDelivered: PropTypes.func.isRequired,
  uploadAttachments: PropTypes.func.isRequired,
};

const defaultProps = {};

function ActionButtons({ data, submitAcceptForImplementation, submitDelivered, uploadAttachments }) {
  const isFormSubmitting = useSelector(state => isSubmitting(formName)(state));

  const statusId = get(data, 'status.id');

  const showAcceptForImplementationButton =
    statusId === transportOrderStatusesIds.placed ||
    statusId === transportOrderStatusesIds.accepted;

  const acceptImplementationLabel =
    statusId === transportOrderStatusesIds.placed
      ? lang.buttons.AcceptForImplementation()
      : lang.buttons.UpdateImplementation();

  const showDeliveredButton = statusId === transportOrderStatusesIds.loaded;
  const [
    deliveredDialogProps,
    openDelivered,
  ] = useFormDialogLogic();


  const acceptImplementationLabels =
    statusId === transportOrderStatusesIds.placed
      ? {
          button: lang.buttons.AcceptForImplementation(),
          description: lang.labels.ChangeStatus(),
        }
      : {
          button: lang.buttons.UpdateImplementation(),
          description: lang.labels.ImplementationDetails(),
        };

  return (
    <>
      {showAcceptForImplementationButton && (
        <ChangeStatusButton
          onClickButton={submitAcceptForImplementation}
          orderStatusId={statusId}
          disabled={isFormSubmitting}
          renderButtonContent={acceptImplementationLabel}
          description={acceptImplementationLabels.description}
          color={statusId === transportOrderStatusesIds.accepted && 'info'}
        />
      )}
      {showDeliveredButton && (
        <>
          <ChangeStatusButton
            onClickButton={openDelivered}
            orderStatusId={statusId}
            renderButtonContent={lang.buttons.Delivered()}
          />
          <DeliveredDialog
            {...deliveredDialogProps}
            onSubmit={submitDelivered}
            uploadAttachments={uploadAttachments}
          />
        </>
      )}
    </>
  );
}

ActionButtons.propTypes = propTypes;
ActionButtons.defaultProps = defaultProps;

export default memo(ActionButtons);
